import React, { Fragment } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, bool } from 'prop-types'

class UserAvatar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      img: props.img,
    }
  }

  render() {
    const { img } = this.state
    const {
      size,
      userName,
      className,
      isWithName,
      width,
      height,
    } = this.props

    return (
      !userName ? (
        <span
          className={classnames(
            'avatar',
            size && `avatar--${size}`,
            className,
            'is-loading',
          )}
        />
      ) : (
        <Fragment>
          <span
            className={classnames(
              'avatar',
              size && `avatar--${size}`,
              className,
              !img && 'is-empty',
              isWithName && 'avatar--with-name',
            )}
          >
            {img ? (
              <img
                src={img}
                alt={userName}
                onError={() => this.setState({ img: null })}
                loading="lazy"
                decoding="async"
                width={width}
                height={height}
              />
            ) : (
              <span>{userName.charAt(0)}</span>
            )}
          </span>
          {isWithName && <span className="cgt-legacy-link">{userName}</span>}
        </Fragment>
      )
    )
  }
}

UserAvatar.propTypes = {
  img: string,
  size: string,
  userName: string,
  className: string,
  isWithName: bool,
  width: string,
  height: string,
}

UserAvatar.defaultProps = {
  img: null,
  size: null,
  userName: null,
  className: null,
  isWithName: false,
  width: undefined,
  height: undefined,
}

export default UserAvatar
